require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./sour-cream-blueberry-compote.json") })
        }
      }, "path---sour-cream-blueberry-compote");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---sour-cream-blueberry-compote!./.cache/json/sour-cream-blueberry-compote.json
// module id = 492
// module chunks = 231608221292675